import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    tableStatus: ["Active", "Inactive"],
    tableBgColor: "#369dc9",
    tabIndex: 0,
};

const tableStatusSlice = createSlice({
    name: 'tableStatus',
    initialState,
    reducers: {
        globalStatusChange: (state, action) => {
            if (action.payload === 1) {
                state.tableStatus = "Active";
                state.tableBgColor = "#2bc155";
                state.tabIndex = 1;
            } else if (action.payload === 2) {
                state.tableStatus = "Inactive";
                state.tableBgColor = "#ffb800";
                state.tabIndex = 2;
            } else if (action.payload === 3) {
                state.tableStatus = "Deleted";
                state.tableBgColor = "rgb(244, 107, 104)";
                state.tabIndex = 3;
            } else {
                state.tableStatus = ["Active", "Inactive"];
                state.tableBgColor = "#369dc9";
                state.tabIndex = 0;
            }
        },
    },
});

export const { globalStatusChange } = tableStatusSlice.actions;
export default tableStatusSlice.reducer;